import React from 'react';
import {Avatar, Typography} from "@mui/material";
import MailIcon from "@mui/icons-material/Mail";
import {useUser} from "../../managers/userManager/userManager";
import Box from "@mui/material/Box";
import {Link} from "react-router";

function UserCard({mobil, handleCloseMenu}) {
    const user = useUser();

    return (
        <Link to={'/user/orders'} style={{textDecoration: 'none', color: 'inherit'}}>
            <Box sx={{
                width: mobil ? 240 : 320,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                borderBottom: mobil ? 'initial' : '1px solid',
                borderColor: 'grey.300',
                mb: mobil ? 'initial' : 1,
                cursor: 'pointer'
            }}
                 onClick={handleCloseMenu}
            >
                <Avatar sx={{width: 60, height: 60, bgcolor: 'grey.300'}}>👤</Avatar>
                <Box sx={{display: 'flex', alignItems: 'center', mt: 1, pb: mobil ? 'initial' : 2}}>
                    <MailIcon sx={{mr: 1}}/>
                    <Typography variant="body2">{user.email}</Typography>
                </Box>
            </Box>
        </Link>
    );
}

export default UserCard;
